// IT
export const propAuthLocksHc = {
  autoridades: {
    breadcrumbCurrent: `Autorità competenti`,
    selectorLabel: `Seleziona l'autorità di polizia della tua zona`,

    // Frammenti di stato condivisi
    msgConnected: `Connesso.`,
    msgValidated: `Validato.`,
    msgValidationError: `Errore di validazione.`,

    // SES Hospedajes
    sesSubtitle: `Segreteria di Stato per la Sicurezza – Ministero dell'Interno`,
    sesConnectedText: `I check-in verranno inviati automaticamente a SES Hospedajes.`,
    sesVerifyCreds: `Verifica le credenziali inserite.`,
    sesNotConnected: `Non hai ancora collegato un account SES Hospedajes.`,
    updateConnectedAccount: `Aggiorna account collegato`,

    // Ertzaintza A19
    ertzSubtitle: `Polizia autonoma dei Paesi Baschi – Registro dei viaggiatori`,
    ertzConnectedText: `I check-in verranno inviati automaticamente all'Ertzaintza.`,
    ertzVerifyCif: `Verifica il CIF e il codice della struttura.`,
    ertzCredsSaved: `Credenziali salvate. Fai clic su "Verifica connessione" per controllare l'accesso.`,
    ertzCifLabel: `CIF della struttura`,
    ertzCifPlaceholder: `Es. B12345678`,
    ertzCifHint: `Max. 10 caratteri. CIF del locatore registrato presso l'Ertzaintza.`,
    ertzCodeLabel: `Codice della struttura`,
    ertzCodePlaceholder: `Es. 01000001`,
    ertzCodeHint: `Assegnato dall'Ertzaintza al momento della registrazione della struttura.`,
    envLabel: `Ambiente`,
    envPre: `Pre-produzione (test)`,
    envPro: `Produzione`,
    envHint: `Usa "Pre-produzione" per validare prima di attivare in produzione.`,
    verifying: `Verifica in corso...`,
    verifyConnection: `Verifica connessione`,
    saving: `Salvataggio...`,
    updateCredentials: `Aggiorna credenziali`,
    saveAndConnect: `Salva e connetti`,

    // Mossos d'Esquadra
    mossosSubtitle: `Generalitat de Catalunya – Registre de viatgers d'establiments d'hostalatge`,

    // SIRE
    sireSubtitle: `Sistema di informazione per la registrazione degli stranieri – Migración Colombia`,
    sireConnectedText: `I check-in verranno inviati automaticamente.`,
    sireRevisaCreds: `Verifica le credenziali.`,
    docTypeLabel: `Tipo di documento`,
    selectTypePlaceholder: `Seleziona il tipo`,
    docNumberLabel: `Numero del documento`,
    docNumberPlaceholder: `Es. 123456789`,
    passwordLabel: `Password`,
    sirePasswordPlaceholder: `Password SIRE`,
    showHideTitle: `Mostra/nascondi`,
    saveChanges: `Salva modifiche`,

    // TRA
    traSubtitle: `Ministero del Commercio, dell'Industria e del Turismo – Token di autorizzazione`,
    traReportsText: `Report automatici abilitati.`,
    traRevisaToken: `Verifica il token/RNT.`,
    traTokenLabel: `Token di autorizzazione`,
    traTokenPlaceholder: `Incolla qui il token emesso dal TRA`,
    traCurrentToken: `Token attuale: {token}`,
    traNoTokenHint: `Se non hai ancora un token PMS, puoi generarlo su`,
    traRntLabel: `RNT della struttura`,
    traRntPlaceholder: `Solo numeri (es. 123456)`,
    traRntHint: `Deve essere l'RNT attivo della struttura (da 5 a 15 cifre).`,

    // Tipi di documento (Colombia)
    docTypeCitizenId: `Carta d'identità del cittadino`,
    docTypeForeignerId: `Carta d'identità per stranieri`,

    // Alloggiati Web (placeholder residuo)
    alloggiatiIdPlaceholder: `Es. 1234`,

    // Notifiche / messaggi dello script
    needSaveListing: `Devi prima salvare l'annuncio.`,
    authChangedErtz: `Autorità cambiata in Ertzaintza (Paesi Baschi).`,
    authChangedMossos: `Autorità cambiata in Mossos d'Esquadra (Catalogna).`,
    authChangedSes: `Autorità cambiata in SES Hospedajes.`,
    authChangeError: `Impossibile cambiare l'autorità.`,
    ertzSaved: `Credenziali Ertzaintza salvate.`,
    saveGenericError: `Errore durante il salvataggio.`,
    ertzSaveError: `Errore nel salvataggio delle credenziali Ertzaintza.`,
    ertzTestOk: `Connessione con l'Ertzaintza verificata con successo.`,
    testFailedCheck: `La verifica è fallita. Controlla i dati.`,
    ertzTestError: `Errore nella verifica della connessione con l'Ertzaintza.`,
    mossosNeedCreds: `Inserisci l'utente e la password del sito dei Mossos.`,
    mossosFound: `{count} struttura trovata. Scegli la tua. | {count} strutture trovate. Scegli la tua.`,
    mossosNoEstablishments: `Nessuna struttura trovata in questo account.`,
    mossosConnError: `Impossibile connettersi ai Mossos. Controlla utente e password.`,
    mossosNeedFields: `Compila l'identificativo di polizia e il codice della struttura.`,
    mossosSaved: `Credenziali Mossos salvate.`,
    mossosSaveError: `Errore nel salvataggio delle credenziali Mossos.`,
    mossosTestOk: `Connessione con i Mossos verificata con successo.`,
    mossosTestError: `Errore nella verifica della connessione con i Mossos.`,
    mossosFileOk: `File generato. Caricalo sul sito dei Mossos (Fitxers massius).`,
    mossosNoTravelers: `Non ci sono viaggiatori in attesa di invio.`,
    mossosConfigFirst: `Configura prima la struttura.`,
    mossosFileError: `Impossibile generare il file.`,
    sireCompleteData: `Completa i dati richiesti per SIRE.`,
    sireSaved: `SIRE salvato con successo.`,
    sireSaveFailed: `Impossibile salvare SIRE.`,
    sireSaveError: `Errore nel salvataggio di SIRE.`,
    sireDeactivated: `SIRE disattivato.`,
    sireActivated: `SIRE attivato.`,
    sireStateFailed: `Impossibile cambiare lo stato di SIRE.`,
    sireStateError: `Errore nel cambio di stato di SIRE.`,
    traNeedToken: `Inserisci il token e un RNT valido (solo numeri).`,
    traSaved: `TRA salvato con successo.`,
    traSaveFailed: `Impossibile salvare TRA.`,
    traSaveError: `Errore nel salvataggio di TRA.`,
    traDeactivated: `TRA disattivato.`,
    traActivated: `TRA attivato.`,
    traStateFailed: `Impossibile cambiare lo stato di TRA.`,
    traStateError: `Errore nel cambio di stato di TRA.`,
    stateChangeFailed: `Impossibile cambiare lo stato.`,
    alloggiatiStateError: `Errore nel cambio di stato di Alloggiati Web.`,
    ross1000StateError: `Errore nel cambio di stato di ROSS 1000.`,
  },

  smartLocks: {
    loadingConfig: `Caricamento della configurazione…`,
    accessKeyTypeLabel: `Tipo di chiave di accesso`,
    selectLockPlaceholder: `Seleziona la serratura`,
    optionStatic: `Chiave statica`,
    optionTtlock: `TTLock - Serratura dinamica`,
    optionTedee: `Tedee - Serratura dinamica`,
    optionShelly: `Shelly - Relè intelligente`,
    optionYacan: `YACAN - Serratura intelligente`,
    optionAkiles: `Akiles - Serratura intelligente`,
    optionOther: `Un'altra marca non presente qui…`,
    pillTedee: `Accesso dinamico (Tedee)`,
    pillTtlock: `Accesso dinamico (TTLock)`,
    pillShelly: `Apertura da remoto (Shelly)`,
    pillYacan: `Accesso gestito (YACAN)`,
    pillAkiles: `Akiles collegato`,
    pillStatic: `Accesso statico`,
    pillOther: `Scrivici e ti aiuteremo a integrarla`,
    disconnecting: `Disconnessione…`,
    disconnect: `Disconnetti`,
    emptyTitle: `Collega la tua serratura intelligente`,
    emptyText: `Scegli la tua marca dal menu a discesa qui sopra per collegarla e generare automaticamente una nuova chiave a ogni prenotazione.`,
    emptyBrandOther: `Altre marche`,
    unitFallback: `Unità {id}`,
    staticModeInfo: `Modalità statica selezionata. Inserisci una chiave e fai clic su Salva per applicarla.`,
    saveTypeError: `Impossibile salvare il tipo di accesso`,
    disconnectSuccess: `Serratura disconnessa`,
    disconnectError: `Impossibile disconnettere la serratura.`,
  },

  rates: {
    pageTitle: `Tariffe`,
    loading: `Caricamento delle tariffe…`,
    roomsCount: `{count} camera | {count} camere`,
    singleUnit: `Unità singola`,
    newBtn: `Nuova`,
    colName: `Nome`,
    colAdjustment: `Regolazione`,
    colFinal: `Prezzo finale`,
    labelMain: `Principale`,
    labelDerived: `Derivata`,
    base: `Base`,
    editTitle: `Modifica`,
    copyTitle: `Copia in un'altra unità`,
    deleteTitle: `Elimina`,
    noDerived: `Non ci sono tariffe derivate per questo rate plan.`,
    emptyTitle: `Nessuna tariffa principale`,
    emptyText: `Crea una tariffa principale per questa unità e poi potrai creare quelle derivate.`,
    emptyCreate: `Crea la prima tariffa principale`,
    globalEmptyTitle: `Nessuna unità caricata`,
    globalEmptyText: `Crea prima camere/unità per poter gestire le tariffe.`,
    editRate: `Modifica tariffa`,
    newRate: `Nuova tariffa`,
    fieldName: `Nome`,
    namePlaceholder: `Es.: Tariffa flessibile`,
    validityPeriod: `Periodo di validità`,
    validityPermanent: `Permanente`,
    validityCustom: `Personalizzato`,
    validityHintCustom: `Facoltativo: si applica solo nell'intervallo`,
    validityHintPermanent: `Tariffa sempre valida`,
    startLabel: `Inizio`,
    endLabel: `Fine`,
    pricePerNight: `Prezzo a notte`,
    taxIncluded: `Tasse incluse`,
    occupancy: `Occupazione`,
    guestsNumber: `Numero di ospiti`,
    minStay: `Soggiorno minimo`,
    maxStay: `Soggiorno massimo`,
    description: `Descrizione`,
    optional: `Facoltativo`,
    rateplanBase: `Rate Plan di base`,
    selectRateplanBase: `Seleziona un rate plan di base`,
    rateplanBaseHint: `Seleziona il rate plan su cui verrà calcolata questa tariffa derivata.`,
    derivedNamePlaceholder: `Es.: Booking.com, Airbnb…`,
    derivedNameHint: `Questo nome ti aiuta a identificare la tariffa nel mappare le OTA.`,
    adjustmentType: `Tipo di regolazione`,
    percentage: `Percentuale`,
    fixedAmount: `Importo fisso`,
    adjustmentValue: `Valore della regolazione`,
    adjustmentValueHint: `(negativo per uno sconto)`,
    preview: `Anteprima`,
    basePrice: `Prezzo base`,
    increment: `Aumento`,
    discount: `Sconto`,
    cancel: `Annulla`,
    saving: `Salvataggio...`,
    update: `Aggiorna`,
    create: `Crea`,
    deleteModalTitle: `Elimina tariffa`,
    deleteWarnStrong: `Questa azione non può essere annullata.`,
    deleteWarnLead: `Stai per eliminare:`,
    deleteCascadeLabel: `Elimina anche le sue tariffe derivate ({count})`,
    deleteCascadeHint: `Se una tariffa derivata è collegata a una OTA, l'eliminazione verrà bloccata.`,
    deleteConfirmLabel: `Scrivi il nome esatto per confermare:`,
    deleteConfirmPlaceholder: `Scrivi esattamente il nome`,
    deleteConfirmHint: `Questo evita eliminazioni accidentali.`,
    deleting: `Eliminazione...`,
    deleteConfirmBtn: `Elimina definitivamente`,
    copyModalTitle: `Copia la tariffa in un'altra unità`,
    copyOrigin: `Origine:`,
    copyRate: `Tariffa:`,
    copyTargetUnit: `Unità di destinazione`,
    selectUnit: `Seleziona un'unità`,
    copySameUnitHint: `Non puoi copiare nella stessa unità.`,
    copyTargetBaseRate: `Tariffa base di destinazione`,
    selectMainRate: `Seleziona una tariffa principale`,
    copyDerivedHint: `Questa tariffa derivata verrà collegata a quella tariffa principale nell'unità di destinazione.`,
    copyNoMainRates: `L'unità di destinazione non ha tariffe principali. Crea o copia prima una principale.`,
    copyNewNameLabel: `Nome nella destinazione`,
    copyRenameHint: `Puoi rinominarla per evitare duplicati.`,
    copyCascadeLabel: `Copia anche le derivate ({count})`,
    copyCascadeHint: `Verranno create nuove tariffe derivate che puntano al rate plan principale copiato.`,
    copying: `Copia in corso...`,
    copyBtn: `Copia`,

    // Notifiche / messaggi dello script
    loadError: `Errore durante il caricamento delle tariffe`,
    rangeErrorSelect: `Devi selezionare un intervallo di date valido`,
    rangeErrorStartEnd: `La data di inizio non può essere successiva alla data di fine`,
    rangeErrorMinStay: `Il soggiorno minimo è di {minStay} notti, ma l'intervallo selezionato ha {nights} notti`,
    invalidUnit: `Unità non valida`,
    completeRequired: `Compila i campi obbligatori`,
    updated: `Aggiornato`,
    created: `Creato`,
    saveError: `Errore durante il salvataggio`,
    deleted: `Eliminato`,
    deleteLinkedOta: `Impossibile eliminare: è collegata a una OTA.`,
    deleteGenericError: `Errore durante l'eliminazione`,
    deleteDerivedError: `Impossibile eliminare la derivata`,
    copied: `Copiato`,
    copyGenericError: `Errore durante la copia`,
    invalidTargetUnit: `Unità di destinazione non valida`,
    selectTargetBaseError: `Seleziona la tariffa base di destinazione per collegare la derivata.`,
    invalidTargetBaseError: `La tariffa base di destinazione selezionata non è valida per l'unità di destinazione.`,
    defaultRateName: `Tariffa`,
    defaultDerivedName: `Derivata`,
    copySuffix: `(Copia)`,
  },
};
